function Penelopet_A11y() {
	console.log('Starting A11y Fixing...');

    const $ = cash;

    $.announce();

    // 4.1.2, 2.5.3
    (() => {
        const $toggle = $('[data-popdown-toggle="search-popdown"]');
        const $searchForm = $('.search-popdown');
        const $close = $searchForm.find('.search__predictive__close__inner');

        $toggle.attr('role', 'button');

        $toggle.removeAttr('aria-haspopup').removeAttr('aria-controls');

        $searchForm.find('.search-reset').removeAttr('aria-label');

        $toggle.on('click', () => {
            $searchForm.trapFocus($toggle);
        });

        $close.on('click', () => {
            $toggle.get(0).focus();
            $searchForm.untrapFocus();
        });

        $searchIcon = $toggle.find('svg').clone();

        $searchForm.find('.search__predictive__button').append($searchIcon);
    })();


    let returnToQuickViewBtn = null;

    (() => {
        $productItems = $('product-grid-item');

        $productItems.each((i, item) => {
            const $item = $(item);
            const $gridLink = $item.find('a[data-grid-link]');
            const link = $gridLink.attr('href').trim();
            const $addToCart = $item.find('button[data-add-to-cart]');
            const $quickViewButton = $item.find('.quickview > button');
            const title = $item.find('.product__grid__title').text().trim();

            let j = 0;

            $quickViewButton.attr({
                'aria-label': `Quick View (${title})`
            }).removeAttr('title');

            $quickViewButton.on('click', () => {
                $.announce('Loading...');

                returnToQuickViewBtn = $quickViewButton.get(0);
            });

            $addToCart.attr({
                'aria-label': `Add to cart (${title})`
            }).removeAttr('title');

            $imageWrapppers = $item.find('product-grid-item-image');

            $gridLink.attr({
                'role': 'application',
                'aria-roledescription': 'product image slider'
            });

            $gridLink.on('focus', () => {
                const itemVariant = $gridLink.closest('product-grid-item-variant').get(0);
                if (itemVariant) {
                    const mouseEnterEvent = new MouseEvent('mouseenter', { bubbles: true, cancelable: true, view: window });
                    itemVariant.dispatchEvent(mouseEnterEvent);

                    const leaveEvent = new MouseEvent('mouseleave', { bubbles: true, cancelable: true, view: window });
                    itemVariant.dispatchEvent(leaveEvent);
                }

                $.announce('Use left and right arrow keys to change product images.');
            });


            $gridLink.on('keydown', (e) => {
                if(e.key === 'ArrowRight') {
                    e.preventDefault();

                    if(j >= $imageWrapppers.length - 1) {
                        return;
                    }

                    $('.product-grid-item__container').eq(i).find('product-grid-item-image').eq(j).removeClass('is-active');

                    j++;

                    $('.product-grid-item__container').eq(i).find('product-grid-item-image').eq(j).addClass('is-active');
                    $.announce(`Slide Changed to ${j + 1}/${$imageWrapppers.length}`);
                }

                if(e.key === 'ArrowLeft') {
                    e.preventDefault();
                    if(j <= 0) {
                        return;
                    }

                    $('.product-grid-item__container').eq(i).find('product-grid-item-image').eq(j).removeClass('is-active');

                    j--;

                    $('.product-grid-item__container').eq(i).find('product-grid-item-image').eq(j).addClass('is-active');
                    $.announce(`Slide Changed to ${j + 1}/${$imageWrapppers.length}`);
                }
            });

            $addToCart.on('click', async () => {
                const $popdown = await $.poll('.product-add-popdown.is-visible');

                if($popdown && $popdown.length > 0) {
                    $popdown.find('.popdown__close__inner').on('click', () => {
                        $addToCart.get(0).focus();
                    });
                };
            });
            

            const $errorEl = $item.find('.product-grid-item__error-display');

            $errorEl.attr('tabindex', -1);

            $errorEl.observe(() => {
                setTimeout(() => {
                    $errorEl.get(0).focus();
                }, 1000);
            }, {attributes: true, attributeFilter: ['style']});
            
            if(item.querySelector('[data-grid-link] .product__grid__price')) {
                $(item).find(`[data-grid-link] .product__grid__price`).insertAfter($(item).find('[data-grid-link]'));
            };

            if(item.querySelector('[data-grid-link] .product__grid__title__wrapper')) {
                $(item).find(`[data-grid-link] .product__grid__title__wrapper`).insertAfter($(item).find('[data-grid-link]'));
            };

            $(item).find('.compare-at').prepend(`<span class="sr-only">Deleted Price:</span>`).insertHiddenClone();
            $(item).find('.price.on-sale').prepend(`<span class="sr-only">Current Price:</span>`).insertHiddenClone();

        });
    })();

    (async () => {
        const $popdown = await $.poll('.product-add-popdown');

        $popdown.observe(() => {
            if($popdown && $popdown.length > 0 && $popdown.hasClass('is-visible')) {
                $popdown.untrapFocus();

                setTimeout(() => {
                    $popdown.trapFocus();
                }, 1000);
            };
        }, {attributes: true, attributeFilter: ['class']});
    })();


    (() => {
        const handleProductItem = () => {
            $('product-grid-item').each((i, item) => {
                $(item).find('.compare-at').prepend(`<span class="sr-only">Deleted Price:</span>`);
                $(item).find('.price.on-sale').prepend(`<span class="sr-only">Current Price:</span>`);
            });
        };

        const handlePagination = () => {
            $('.pagination-custom').each((i, pagination) => {
                $(pagination).parent().attr({
                    'role': 'navigation',
                    'aria-label': 'Pagination'
                });
                
                $(pagination).find('.pagination-custom__num').each((i, li) => {
                    const $a = $(li).find('a');

                    $a.attr('aria-label', `Page ${$a.text().trim()}`);

                    if(li.classList.contains('active')) {
                        $(li).find('span').attr('aria-hidden', true);
                        $(li).prepend(`<span class="sr-only"> Current page ${li.textContent.trim()}</span>`);
                    }
                });

                $(pagination).find('.pagination-custom__arr').first().find('a').attr('aria-label', 'Previous page').removeAttr('title');
                $(pagination).find('.pagination-custom__arr').last().find('a').attr('aria-label', 'Next page').removeAttr('title');
            });
        };

        $('.collection__products').observe(() => {
            handleProductItem();
            handlePagination();
        }, {attributes: true, attributeFilter: ['class'], runOnInit: true});
    })();

    // 1.1.1
    (() => {
        $collections = $('.section-list-collections.list__collections');

        $collections.each((i, collection) => {
            $(collection).find('.link-over-image').removeAttr('aria-label');
            $(collection).find('.image__hero__scale img').attr('alt', '');
        });
    })();

    // 2.4.6, 4.1.2, 4.1.3, 1.3.1
    (() => {
        const $cartLink = $('.navlink--cart');
        const $cartDrawer = $('.cart__drawer');

        let returnToIndex = 0;
        let returnToSelector = ''; 

        $cartLink.attr({
            'role': 'button',
            'aria-expanded': false
        });
        
        $cartDrawer.find('.drawer__close').on('click', () => {
            $cartLink.get(0).focus();
        });

        $cartDrawer.find('.cart__drawer__title').attr({
            'role': 'heading',
            'aria-level': 2
        });

        const handleItems = () => {
            $cartDrawer.find('.cart__items__row').each((i, item) => {
                const $item = $(item);
                const title = $item.find('.cart__items__title a').text().trim();
                const $removeBtn = $item.find('a[data-remove-key]');
                const $decreaseBtn = $item.find('button[data-decrease-quantity]');
                const $increaseBtn = $item.find('button[data-increase-quantity]');
                const $quantityLabel = $(item).find('[data-quantity-input]').prev();

                $removeBtn.attr({
                    'aria-label': `Remove ${title}`,
                    'role': 'button'
                });

                $increaseBtn.attr({
                    'aria-label': `Increase quantity of ${title}`,
                    'role': 'button'
                });

                $decreaseBtn.attr({
                    'aria-label': `Decrease quantity of ${title}`,
                    'role': 'button'
                });

                $quantityLabel.text(`Quantity of ${title}`);

                $removeBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'a[data-remove-key]';
                    $.announce(`Removing ${title} from cart`);
                });

                $decreaseBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'button[data-decrease-quantity]';
                    $.announce(`Decreasing quantity of ${title}`);
                });

                $increaseBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'button[data-increase-quantity]';
                    $.announce(`Increasing quantity of ${title}`);
                });

                $item.find('.cart__items__price del').prepend(`<span class="sr-only">Price: </span>`);
                $item.find('.cart__items__price mark').prepend(`<span class="sr-only">Current Price: </span>`);
            });
        }

        handleItems();

        $cartDrawer.observe(() => {
            $cartLink.attr('aria-expanded', $cartDrawer.hasClass('drawer--visible'));

            if($cartDrawer.hasClass('drawer--visible')) {
                $cartDrawer.find('.drawer__content').untrapFocus();

                setTimeout(() => {
                    $cartDrawer.find('.drawer__content').trapFocus(); 

                    handleItems();
                }, 1000);
            }
        }, {attributes: true, attributeFilter: ['class']});

       
        $cartDrawer.find('[data-cart-form]').observe((mutations) => {
            if($cartDrawer.hasClass('drawer--visible')) {
                $cartDrawer.find('.drawer__content').untrapFocus();

                setTimeout(() => {
                    $cartDrawer.find('.drawer__content').trapFocus(); 

                    if(returnToIndex > -1 && returnToSelector) {
                        $cartDrawer.find('.cart__items__row').eq(returnToIndex).find(returnToSelector).get(0).focus();
                    }
                }, 1000);
            }
            
            handleItems();
        }, {childList: true, attributes: true, attributeFilter: ['class']});
    })();


    (() => {
        const $cartPage = $('.template-cart');

        let returnToIndex = 0;
        let returnToSelector = null;

        $cartPage.find('[data-line-items]').observe(() => {
            $cartPage.find('.cart__items').attr('role', 'table');

            $cartPage.find('.cart__items__row').each((i, item) => {
                const $item = $(item);
                const title = $(item).find('.cart__items__title > p').text().trim();
                const $removeBtn = $item.find('a[data-remove-key]');
                const $decreaseBtn = $item.find('button[data-decrease-quantity]');
                const $increaseBtn = $item.find('button[data-increase-quantity]');
                const $quantityLabel = $(item).find('[data-quantity-input]').prev();

                $item.attr('role', 'row');

                $item.children().attr('role', 'none');

                $removeBtn.attr({
                    'aria-label': `Remove ${title}`,
                    'role': 'button'
                });

                $increaseBtn.attr({
                    'aria-label': `Increase quantity of ${title}`,
                    'role': 'button'
                });

                $decreaseBtn.attr({
                    'aria-label': `Decrease quantity of ${title}`,
                    'role': 'button'
                });

                $quantityLabel.text(`Quantity of ${title}`);

                $removeBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'a[data-remove-key]';
                    $.announce(`Removing ${title} from cart`);
                });

                $decreaseBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'button[data-decrease-quantity]';
                    $.announce(`Decreasing quantity of ${title}`);
                });

                $increaseBtn.on('click', () => {
                    returnToIndex = i;
                    returnToSelector = 'button[data-increase-quantity]';
                    $.announce(`Increasing quantity of ${title}`);
                });

                $item.find('.cart__items__price del').prepend(`<span class="sr-only">Price: </span>`);
                $item.find('.cart__items__price mark').prepend(`<span class="sr-only">Current Price: </span>`);

                $item.find('.cart__items__remove').insertAfter($item.find('.cart__items__title'));

                $item.find('.cart__items__grid').children().attr({
                    'role': 'cell',
                });

                if(returnToIndex > -1 && returnToSelector) {
                    $cartPage.find('.cart__items__row').eq(returnToIndex).find(returnToSelector).get(0).focus();
                    returnToIndex = -1;
                    returnToSelector = null;
                }
            });
        }, {childList: true, runOnInit: true});

        $cartPage.find('.cart__page__title').attr({
            'role': 'heading',
            'aria-level': 1
        });

        $cartPage.find('.cart__heading__wrapper').children().each((i, item) => {
            $(item).attr('id', item.getAttribute('class'));
        });

        $cartPage.find('.cart__empty__page .cart__empty p').attr('tabindex', -1).get(0)?.focus();
    })();


    (() => {
        $quickViewModal = $('.quickview__modal');

        const handleClose = (e) => {
            if(returnToQuickViewBtn) {
                returnToQuickViewBtn.focus();
            }
        };

        const handleQuickViewContent = () => {
            $quickViewModal.find('.radio__fieldset').each((i, fieldset) => {
                $(fieldset).find('input[type="radio"]').each((i, input) => {
                    $input = $(input);

                    if($input.hasClass('sold-out')) {
                        $input.attr('aria-label', `${$input.attr('value')} (Sold Out)`);
                    }
                })
            });

            $quickViewModal.find('.drawer__body').attr({
                'tabindex': 0,
                'aria-label': 'Scroll with arrow up and down to see more images'
            });

            $quickViewModal.find('button[data-add-to-cart]').on('click', () => {
                $.announce('Loading...');
            });

            $quickViewModal.find('.drawer__close').on('click', handleClose);
        };

        handleQuickViewContent();

        $quickViewModal.observe(() => {
            if($quickViewModal.hasClass('is-open')) {
                $quickViewModal.find('.drawer__button.drawer__close').removeAttr('tabindex');

                handleQuickViewContent();
            }
        }, {attributes: true, attributeFilter: ['class']})
    })();

    (async () => {
        let returnTo = null;

        const $carousel = await $.poll('flickity-carousel .flickity-grid, flickity-carousel [data-carousel]'); 

        if(!$carousel || $carousel.length < 1) return;

        $('flickity-carousel').each((i, carousel) => {
            $(carousel).children().each((i, slider) => {
                $(slider).removeAttr('tabindex');

                $(slider).find('.gallery__item').each((i, item) => {
                    const $trigger = $(item).find('.zoom__trigger');

                    $trigger.attr({
                        'tabindex': 0,
                        'role': 'button'
                    });

                    $trigger.on('click', (e) => {
                        returnTo = $trigger.get(0);
                    });

                    $trigger.on('keydown', function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // prevent scrolling when using space
                            $(this).trigger('click');
                        }
                    });
                })
            });

            $(carousel).find('.flickity-prev-next-button').each((i, button) => {
                $(button).on('click', () => {
                    $.announce('Slide changed')
                });
            });
        });

        $micromodal = $('[data-modal-container]');
        
        await $.poll('[data-modal-container] .modal__close');

        $micromodal.find('.modal__close').each((i, close) => {
            $(close).on('click', () => {
                returnTo?.focus();
            });
        });
    })();

    (() => {
        $slideShow = $('.slideshow__wrapper');

        $slideShow.removeAttr('tabindex');

        if(parseInt($slideShow.attr('data-slideshow-slides')) < 2) {
            $slideShow.find('.flickity-page-dots').remove();
        };

    })();

    (() => {
        let returnTo = null;
        let returnToIndex = 0;

        $('.product__grid--slides').each((i, slider) => {
            $(slider).removeAttr('tabindex');
        })

        $('.product-section .flickity-slider .product__media').each((i, slide) => {
            $zoomBtn = $(slide).find('.media__button--zoom');

            $zoomBtn.on('click', () => {
                returnTo = $zoomBtn.get(0);
                returnToIndex = i;
            });
        });

        $pswp = $('.pswp');

        $pswp.find('.pswp__button--close').on('click', () => {
            setTimeout(() => {
                $('.product-section .flickity-slider .product__media').eq(returnToIndex).find('.media__button--zoom').get(0)?.focus();
            }, 500);
        });

        $pswp.observe((mutations) => {
            $pswp.removeAttr('tabindex').removeAttr('role').removeAttr('aria-hidden');
            if($pswp.hasClass('pswp--visible')) {
                $pswp.trapFocus(returnTo);
            } else {
                $pswp.untrapFocus();
            }
        }, {attributes: true, attributeFilter: ['class'], runOnInit: true});


        $('.media__thumb__holder').each((i, thumbs) => {
            $(thumbs).find('.media__thumb').each((i, thumb) => {
                const $thumb = $(thumb);
                const ariaLabel = $thumb.attr('aria-label').trim(); 

                $thumb.attr({
                    'role': 'button',
                    'tabindex': 0,
                });

                $thumb.on('keydown', (e) => {
                    if(e.key === 'Enter') {
                        $thumb.trigger('click');
                    }
                });

                $thumb.observe(() => {
                    if($thumb.hasClass('is-activated')) {
                        $thumb.attr('aria-label', `${ariaLabel} (Selected)`);
                    } else {
                        $thumb.attr('aria-label', `${ariaLabel}`);
                    }
                }, {attributes: true, attributeFilter: ['class'], runOnInit: true});
            });
        });

    })();

    (() => {
        $productContent = $('.product__main__content');

        $productContent.find('.radio__fieldset').each((i, fieldset) => {
            $(fieldset).find('input[type="radio"]').each((i, input) => {
                $input = $(input);

                if($input.hasClass('sold-out')) {
                    $input.attr('aria-label', `${$input.attr('value')} (Sold Out)`);
                }
            })
        });
    })();

    (async () => {
        $formRows = await $.poll('.klaviyo-form [data-testid="form-row"]');

        if(!$formRows || $formRows?.length < 1) return;

        setTimeout(() => {
            $formRows?.each((i, row) => {
                $combobox = $(row).find('input[role="combobox"]');
                $listbox = $(row).find('[role="listbox"]');
                $email = $(row).find('input[type="email"]');
                $submit = $(row).find('button[type="button"]');

                if($combobox.length > 0) {
                    $(`<label for="${$combobox.attr('id')}">${$combobox.attr('aria-label')}</label>`).insertBefore(row);
                    $combobox.removeAttr('aria-labelledby');
                };

                if($listbox.length > 0) {
                    $listbox.removeAttr('aria-labelledby');
                };

                if($email.length > 0) {
                    $(`<label for="${$email.attr('id')}">${$email.attr('aria-label')}</label>`).insertBefore(row);
                };

                $submit.on('click', () => {
                    $.announce('Loading...');
                });
            });
        }, 1000);
    })();


    // 2.1.1
    (() => {
        const $nav = $('nav.header__menu');

        $nav.find('.menu__item[aria-haspopup]').each((i, item) => {
            const $button = $(`<button><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 9l6 6l6 -6" /></svg></button>`); 

            $button.insertAfter($(item).children('a'));

            $button.attr({
                'aria-label': `${$(item).children('a').text().trim()}`
            });

            $button.on('click', () => {
                $(item).toggleClass('is-visible');
                $(item).children('.header__dropdown').toggleClass('is-visible');
            });

            $(item).observe(() => {
                $button.attr('aria-expanded', item.classList.contains('is-visible'));
                $(item).removeAttr('role').removeAttr('aria-expanded');

            }, {attributes: true, attributeFilter: ['class'], runOnInit: true});
        });

        $nav.children().attr('role', 'list');
        $nav.children().children('.menu__item').attr('role', 'listitem');
        $nav.children().children('*:not(.menu__item)').attr('role', 'none');

        $('.header__desktop__buttons').each((i, buttons) => {
            $(buttons).attr('role', 'list');
            $(buttons).children().attr('role', 'listitem');
        });
    })();

    // 1.3.1
    (() => {
        $([
            '.template-index .standard__kicker.accent-size-4 > p'
        ].join(',')).attr({
            'role': 'heading',
            'aria-level': 2
        });
    })();
    
    // 4.1.3,4.1.2
    (async () => {
        const $instafeedModal = await $.poll('.instafeed-modals-wrapper');

        if(!$instafeedModal || $instafeedModal.length < 1) return;

        $instafeedModal.find('.prev, .next').on('click', () => {
            $.announce('Slide changed');
        });

        $instafeedModal.find('.instafeed-close-button').attr({
            'role': 'button',
            'aria-label': 'Close'
        });
    })();

    (async () => {
        const $instafeed = $('#insta-feed');
        const $wrapper = await $.poll('#insta-feed .instafeed-new-layout-wrapper');

        if(!$wrapper || $wrapper.length < 1) return;


        
        $wrapper.children().each((i, el) => {
            new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        $(el).css({
                            'visibility': 'visible'
                        });
                    } else {
                        $(el).css({
                            'visibility': 'hidden'
                        });
                    }
                });
            }, {
                root: null,
                rootMargin: "0px",
                threshold: 0.1,
            }).observe(el);
        });

        $wrapper.observe((mutations) => {


        }, {attributes: true, attributeFilter: ['style']});
    })();

    (() => {
        const $footer = $('footer');

        if(window.matchMedia("(min-width: 767px)").matches) {
            $footer.find('.footer__accordion__head').each((i, button) => {
                $(button).removeAttr('role').removeAttr('aria-haspopup').removeAttr('aria-expanded').removeAttr('aria-controls');
            });
        };

        const $subfooter = $('.subfooter');

        $subfooter.find('.subfooter__item--social').attr('role', 'list').children().attr('role', 'listitem');

        $subfooter.find('.subfooter__select--locale .popout__toggle').each((i, button) => {
            $(button).attr('aria-label', `Language: ${button.textContent.trim()}`);
            $(button).removeAttr('aria-describedby');

            $(button).closest('.subfooter__select').find('#lang-heading-localization-form-footer').removeClass('visually-hidden');
        })
    })();

    (() => {
        const $tampaPhone = $('a[href="tel:813-254-5740"]');
        $tampaPhone.attr('aria-label', `Tampa Phone: ${$tampaPhone.text().trim()}`).removeAttr('title');

        const $jacksonvilleBeachPhone = $('a[href="tel:904-246-7009"]');
        $jacksonvilleBeachPhone.attr('aria-label', `Jacksonville Beach Phone: ${$jacksonvilleBeachPhone.text().trim()}`).removeAttr('title');

        const $fortLauderdalePhone = $('a[href="tel:954-533-1695"]');
        $fortLauderdalePhone.attr('aria-label', `Fort Lauderdale Phone: ${$fortLauderdalePhone.text().trim()}`).removeAttr('title');
    })();

    // 3.3.2
    (() => {
        const $contactForm = $('.contact-form');

        if(!$contactForm || $contactForm.length < 1) {
            return;
        }

        const $errors = $contactForm.find('.errors');

        $contactForm.find('.float__wrapper').each((i, field) => {
            const $label = $(field).find('label');
            const $input = $(field).find('input,select,textarea');
            $errors.find(`li`).each((i, li) => {
                if($(li).text().trim().includes($label.text().trim())) {
                    $(field).append(`<div class="error" id="${$input.attr('id')}-error">${li.textContent.trim()}</div>`);
                    $input.attr('aria-describedby', `${$input.attr('id')}-error`);
                }
            });

            $errors.remove();
        });

        $contactForm.find('input[type="email"]').attr('aria-required', true);
        $contactForm.find('[name="contact[full-name]"]').attr('autocomplete', 'name');
        $contactForm.find('[name="contact[email]"]').attr('autocomplete', 'email');
        $contactForm.find('[name="contact[telephone]"]').attr('autocomplete', 'tel');


        setTimeout(() => {
            $contactForm.find('[aria-describedby]')?.get(0)?.focus();
            $contactForm.find('.form-success')?.attr('tabindex', -1)?.get(0)?.focus();
        }, 2000);
    })();

    (() => {
        $('#contact').find('.standard__kicker').insertHiddenClone({
            tag: 'h1'
        });

        $('#our-brands').find('.standard__kicker').insertHiddenClone({
            tag: 'h1'
        });

        $('#store-locations').find('.standard__heading p').insertHiddenClone({
            tag: 'h1'
        });

        $('#fort-lauderdale').find('.standard__heading p').insertHiddenClone({
            tag: 'h1'
        });
    })();

    (() => {
        const handleList = (i, list) => {
            const $list = $(list);
            const $char = $list.find('li strong').first();
            if (!$char.length) return; // skip if no strong found

            const charText = $char.text().trim();
            if (!charText) return;

            // Insert accessible heading before the list
            $char.insertBefore($list).attr({
                'role': 'heading',
                'aria-level': 2
            }).addClass('col-list-title');

            // Clean up list: remove empty <li>
            $list.find('li').filter((_, li) => !$(li).text().trim()).remove();

            // If list is now empty, remove entirely
            if ($list.children('li').length === 0) {
                $list.remove();
                return;
            }

            // Find all <li> starting with the heading character
            const matchingItems = $.xpath(
                `.//li[normalize-space(.) != '' and starts-with(normalize-space(.), '${charText}')]`,
                list
            );

            // If none match, stop
            if (!matchingItems.length) return;

            // Wrap matches in a new <ul>
            const $newList = $('<ul class="col-list" role="list"></ul>').append(matchingItems);

            // Insert the new grouped list before the original list
            $newList.insertBefore($list);

            // Optionally remove the original list if it becomes empty
            if ($list.children('li').length === 0) {
                $list.remove();
            }
        };

        $('#our-brands').find('.col-list').each(handleList);
        $('#our-brands').find('.col-list').each(handleList);
    })();


    // 4.1.2
    (() => {
        const $filters = $('.collection__filters__wrapper');

        $filters.find('button[data-accordion-trigger]').each((i, button) => {
            const $button = $(button);

            $button.find('.sidebar__heading-chevron').attr('aria-hidden', true);
        });

        $('.collection__filters__inner').attr('role', 'list');
        $('.collection__filters__inner [data-sidebar-filter-form]').attr('role', 'none');
        $('.collection__filters__inner .sidebar__filter__group').attr('role', 'listitem');

        $filters.find('[data-accordion-body]').each((i, group) => {
            $(group).attr({
                'role': 'group',
                'aria-label': $(group).prev('label').find('span').first().text().trim()
            });
        });
    })();

    (() => {
        const $refundPolicyPage = $('#refund-policy');

        $refundPolicyPage.find('h4').attr({
            'role': 'heading',
            'aria-level': 2
        });

        $refundPolicyPage.find('h5').attr({
            'role': 'heading',
            'aria-level': 3
        });

    })();

    (() => {
        $('#about').find('.standard__heading > p').first().attr({
            'role': 'heading',
            'aria-level': 1
        }).insertHiddenClone({
            attributes: {
                'role': 'heading',
                'aria-level': 1
            }
        });
    })();

    $('.lp99_wte-section').each(function () {
    var title = $(this).find('.lp99_section-title').text().trim();
    $(this).find('button').attr('aria-label', title + ' details');
});
    
	console.log('Completed A11y Fixing.');
}

document.addEventListener('DOMContentLoaded', () => {
	try {
		Penelopet_A11y();
	} catch(error) {
		console.log(error);
	}
});